import { MessageDescriptor, PrimitiveType, useIntl } from "react-intl";

const useTranslateMessage = function () {
  const intl = useIntl();
  return function (
    message: MessageDescriptor,
    values?: Record<string, PrimitiveType>,
  ) {
    return intl.formatMessage(message, values);
  };
};

export default useTranslateMessage;
